// extracted by mini-css-extract-plugin
export default {"container":"pdfTabContent_container__I1sWW"};